import React, { useState, useEffect } from 'react';
import { PieChart, Pie, ResponsiveContainer, Cell } from 'recharts';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import Collabrative from "../../../../Assets/Images/Collabrative.png";
import Strategic from '../../../../Assets/Images/strat.png';
import Performance from '../../../../Assets/Images/perfor.png';
import Visionary from '../../../../Assets/Images/vis.png';
import { isFullTie, LEADERSHIP_CLOCKWISE } from '../../../../utils/quadrantTieOrder';

export default function LeadershipStyle3({ apiData, pageNumber }) {

  const [highestLeadershipStarter, setHighestLeadershipStarter] = useState('')
  const [variablsMapArray, setVariableMapArray] = useState()

  const styles = {
    checkboxStyles: `input[type='checkbox'] { width: 10px; height: 10px; opacity: 1; border-radius: 2px; border: 1px solid #000000; appearance: none; -webkit-appearance: none; display: inline-block; vertical-align: middle; margin: 0px 2px 0px 0px; transform: rotate(0deg); background-color: transparent; }`,
    page: { fontFamily: "Helvetica, sans-serif", color: "#333333", lineHeight: "1.6", backgroundColor: "#FFFFFF" },
    aboutSection: { paddingTop: "16px", margin: 0 },
    title: { fontFamily: "Helvetica, sans-serif", fontWeight: 700, fontStyle: "normal", fontSize: "14px", lineHeight: "18px", letterSpacing: "0px", textTransform: "uppercase", marginBottom: "13px", marginTop: 0, color: "#00577D" },
    iconRow: { display: "flex", justifyContent: "start", alignItems: "start", gap: "6px", paddingBottom: "16px" },
    iconImage: { width: "108px", height: "108px" },
    iconText: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, flex: 1, paddingBottom: "16px" },
    iconText2: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, flex: 1, },
    card: { marginBottom: "16px", backgroundColor: "#F1F8F1", padding: "12px", borderRadius: "5px", display: "flex", flexDirection: "column", gap: "8px" },
    cardChallenges: { padding: "12px", borderRadius: "5px", background: "#FFF0EC", display: "flex", flexDirection: "column", gap: "12px" },
    cardTitle: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", fontWeight: 700, margin: 0, color: "#000000", letterSpacing: "0px", textTransform: "uppercase" },
    list: { fontFamily: "Helvetica, sans-serif", fontSize: "10px", lineHeight: "14px", fontWeight: 400, color: "#000000",  margin: 0, listStyle: "none", padding: "0px" },
    labelStyle: { fontFamily: "Helvetica, sans-serif", fontWeight: 700, fontStyle: "normal", fontSize: "10px", lineHeight: "14px", letterSpacing: "0px", color: "#000000" },
  };


  const leadershipPairs = [
    { round1: "col_round1_m", round2: "col_round2_m" },
    { round1: "strat_round1_m", round2: "strat_round2_m" },
    { round1: "per_round1_m", round2: "per_round2_m" },
    { round1: "vis_round1_m", round2: "vis_round2_m" }
  ]

  useEffect(() => {
    const variableMap = apiData?.variables?.reduce((acc, el) => {
      acc[el.variable] = el.score;
      return acc;
    }, {});
    setVariableMapArray(variableMap)
  }, [apiData])


  useEffect(() => {

    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      // console.log(variablsMapArray);
      const performance_r1_m = variablsMapArray["per_round1_m"] || 0;
      const strategic_r1_m = variablsMapArray["strat_round1_m"] || 0;
      const visionary_r1_m = variablsMapArray["vis_round1_m"] || 0;
      const collaborative_r1_m = variablsMapArray["col_round1_m"] || 0;

      const performance_r2_m = variablsMapArray["per_round2_m"] || 0;
      const strategic_r2_m = variablsMapArray["strat_round2_m"] || 0;
      const visionary_r2_m = variablsMapArray["vis_round2_m"] || 0;
      const collaborative_r2_m = variablsMapArray["col_round2_m"] || 0;

      const performance_r1_l = variablsMapArray["per_round1_l"] || 0;
      const strategic_r1_l = variablsMapArray["strat_round1_l"] || 0;
      const visionary_r1_l = variablsMapArray["vis_round1_l"] || 0;
      const collaborative_r1_l = variablsMapArray["col_round1_l"] || 0;

      const performance_r2_l = variablsMapArray["per_round2_l"] || 0;
      const strategic_r2_l = variablsMapArray["strat_round2_l"] || 0;
      const visionary_r2_l = variablsMapArray["vis_round2_l"] || 0;
      const collaborative_r2_l = variablsMapArray["col_round2_l"] || 0;


      const collaborative_highest = Math.max(collaborative_r1_m, collaborative_r2_m, collaborative_r1_l, collaborative_r2_l);
      const strategic_highest = Math.max(strategic_r1_m, strategic_r2_m, strategic_r1_l, strategic_r2_l);
      const performance_highest = Math.max(performance_r1_m, performance_r2_m, performance_r1_l, performance_r2_l);
      const visionary_highest = Math.max(visionary_r1_m, visionary_r2_m, visionary_r1_l, visionary_r2_l);


      let most_score = Math.max(performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m)
      let second_most_score = Math.max(performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m) / 2
      let least_score = Math.max(performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l)
      let second_least_score = Math.max(performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l) / 2

      if (least_score >= second_least_score) {
        least_score = (second_least_score - 1)
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100

      // console.log("scores-", most_score, second_most_score, least_score, second_least_score)
      // console.log("scores-per", most_per, second_most_per, least_score, second_least_per)

      let testingVarsM2Pair = [{ "name": "collaborative", "score": collaborative_highest }, { "name": "strategic", "score": strategic_highest }, { "name": "performance", "score": performance_highest }, { "name": "visionary", "score": visionary_highest }];

      highestVariable = testingVarsM2Pair.reduce((max, current) =>
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );

      // console.log(highestVariable);

      let scores = testingVarsM2Pair.map(item => item.score);
      results = [...results, ...scores];

      let labels = testingVarsM2Pair.map(item => item.name);
      labelsArray = [...labelsArray, ...labels];

      leadershipPairs?.forEach(pair => {
        const round1Obj = apiData?.variables.find(v => v.variable === pair.round1);
        const round2Obj = apiData?.variables.find(v => v.variable === pair.round2);
        // console.log("apiData", apiData)

        // console.log("pie chart round1Obj", round1Obj)
        // console.log("pie chart round2Obj", round2Obj)
        if (round1Obj && round2Obj) {
          const snapshotResult = round1Obj.score
          results.push(snapshotResult);
          let label = pair?.round1.split('_')[0];
          if (label === 'col') {
            label = 'collaborative'
          }
          if (label === 'vis') {
            label = 'visionary'
          }
          if (label === 'strat') {
            label = 'strategic'
          }
          if (label === 'per') {
            label = 'performance'
          }
          labelsArray.push(label);

          // if (snapshotResult > highestScore) {
          //   highestScore = snapshotResult;
          //   highestVariable = pair?.round1;
          // }
        }
      });

      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];


      const mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);


      const getPercentageOrder = (label) => {

        if (label == most_label?.toLowerCase()) {
          return most_per;
        }
        if (label == second_most_label?.toLowerCase()) {
          return second_most_per;
        }
        if (label == least_label?.toLowerCase()) {
          return least_per;
        }
        if (label == second_least_label?.toLowerCase()) {
          return second_least_per;
        }

        return 0
      }


      results = [getPercentageOrder("performance"), getPercentageOrder("visionary"), getPercentageOrder("strategic"), getPercentageOrder("collaborative")] // label order = 'performance', 'strategic', 'visionary', 'collaborative'


      // console.log('highestVariable', highestVariable)
      // console.log("pie chart results", results);
      // console.log("pie chart labelsArray", labelsArray);

      // console.log('most_label', most_label)

      // 4-way tie on round 1 'most' counts: clockwise order picks Performance
      setHighestLeadershipStarter(isFullTie(mostValues) ? LEADERSHIP_CLOCKWISE[0] : most_label);
      // setLeadershipSnapshotResults(results);
      // setLeadershipLabels(["collaborative" , "strategic" , "performance", "visionary",  ]);
      // getMostAndSecondMostVaribale(apiData)

    }
  }, [variablsMapArray]);

  const getLeadershipHeading = () => {
    if (highestLeadershipStarter.includes('col')) return 'COLLABORATIVE'
    if (highestLeadershipStarter.includes('strat')) return 'STRATEGIC'
    if (highestLeadershipStarter.includes('per')) return 'PERFORMANCE'
    if (highestLeadershipStarter.includes('vis')) return 'VISIONARY'
  }

  const getLeadershipImg = () => {
    if (highestLeadershipStarter.includes('col')) return Collabrative
    if (highestLeadershipStarter.includes('strat')) return Strategic
    if (highestLeadershipStarter.includes('per')) return Performance
    if (highestLeadershipStarter.includes('vis')) return Visionary
  }

  const getLeadershipInfo = () => {
    if (highestLeadershipStarter.includes('col')) return 'Collaborative Leadership is an extension of the Heart quadrant. These types of leaders excel in creating environments where everyone feels important and valued. They lead in ways that seek to foster a cooperative atmosphere and emphasize respect among team members, helping everyone perform their best.'
    if (highestLeadershipStarter.includes('strat')) return 'Strategic Leadership is an extension of the Mind quadrant. They play a crucial role in shaping an organization by developing robust structures, policies, and frameworks that lay the foundation for success.'
    if (highestLeadershipStarter.includes('per')) return 'Performance Leadership is an extension of the Strength quadrant. Performance Leaders are pivotal in driving organizational success through enhanced efficiency and problem-solving capabilities.'
    if (highestLeadershipStarter.includes('vis')) return 'Visionary Leadership is an extension of the Soul quadrant. These types of leaders are exceptional in their ability to bring leaders, teams, or the organization back to the deeper meaning and purpose behind all the daily activity.'
  }

  const getLeadershipInfo2 = () => {
    if (highestLeadershipStarter.includes('col')) return `Often referred to as "the People’s Leader,” these individuals focus first on relationships and may be naturally attuned to understand and constructively manage the feelings, wants, and needs happening beneath the surface.`
    if (highestLeadershipStarter.includes('strat')) return `These leaders excel at connecting big-picture goals with practical execution. Strategic Leaders are adept at defining clear roles and responsibilities within their teams, ensuring that every member knows their part in achieving organizational success.`
    if (highestLeadershipStarter.includes('per')) return `They can often translate high-level ideas into concrete actions.  Known for their expertise in management, they establish clear benchmarks and objectives that motivate team members to exceed expectations while balancing authority and resources to deliver top-notch customer service.`
    if (highestLeadershipStarter.includes('vis')) return `They often have a unique knack for seeing what others don't and articulating a future that motivates everyone to rally around a shared vision.`
  }

  const getLeadershipInfo3 = () => {
    if (highestLeadershipStarter.includes('col')) return `This can make them empathetic and considerate but they need to be careful not to get too caught up in people's issues to the point where it derails objectives and overrides healthy boundaries.`
    if (highestLeadershipStarter.includes('strat')) return `They are skilled at leveraging existing frameworks and processes to maximize results, always with an eye toward continual improvement and adaptation. However, their focus on control and structure can sometimes lead to challenges, such as overly autocratic decision-making or inflexible policies. `
    if (highestLeadershipStarter.includes('per')) return `However, their focus on goals and performance might lead them to view individuals more as means to an end rather than as whole persons, occasionally overlooking the personal contributions and individual needs of their team members. `
    if (highestLeadershipStarter.includes('vis')) return `They face challenges in translating broad visions into actionable steps, which can frustrate teams eager to implement these ideas.`
  }

  const getLeadershipInfo4 = () => {
    if (highestLeadershipStarter.includes('col')) return `At the heart of collaborative leadership is the belief that working together brings better results than working alone, "If you want to go fast, go alone. If you want to go far, go together."`
    if (highestLeadershipStarter.includes('strat')) return `These are the individuals who combine analytical prowess with operational efficiency, ensuring that the organization not only sets ambitious goals but also achieves them through meticulous strategy and execution. They are the masterminds behind the scenes, turning visions into reality with precision and foresight.`
    if (highestLeadershipStarter.includes('per')) return `Their knack for turning strategic visions into actionable steps ensures that the organization operates smoothly and achieves notable results.`
    if (highestLeadershipStarter.includes('vis')) return `Some Visionary leaders utilize symbols, ceremonies, and storytelling to enrich their leadership narrative, creating a resonant culture that transcends conventional business metrics and fosters a strong sense of community and shared purpose. These are the Sages, who embody wisdom and perspective, often motivated towards building and leaving a legacy.`
  }


  const renderItem = (title, desc) => (
    <li style={{paddingBottom:"4px" , display : "flex", gap : "4px" }}>
      <input type='checkbox' disabled />
      <div>
         <span style={styles.labelStyle}> {title}: </span>
      {desc}
      </div>
     
    </li>
  );

  const pointOne = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Empowering Team Members", "Creates space for people to lead with confidence.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Clear Direction", "Provides clarity on goals and how to achieve them.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Goal Achievement", "Sets ambitious targets and consistently delivers results.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Innovative Thinking", "Introduces bold ideas that expand what’s possible.");
  }

  const pointTwo = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Cross-Team Collaboration", "Connects departments and reduces silos.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Effective Planning", "Builds practical, actionable plans that simplify complex work.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Strong Problem-Solving", "Identifies issues quickly and drives practical solutions.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Inspiring Alignment", "Connects daily work to a compelling mission.");
  }

  const pointThree = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Stakeholder Relationships", "Builds trust with customers, partners, and teams.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Risk Management", "Anticipates and reduces risks before they become problems.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Leading by Example", "Models discipline, commitment, and a high work ethic.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Brand Elevation", "Strengthens the brand through forward-thinking initiatives.");
  }

  const pointFour = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Culture Building", "Shapes a positive, inclusive team culture.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Growing Skills + Learning", "Promotes continuous learning and skill development across the team.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Performance Culture", "Sets clear expectations that motivate teams to excel.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Culture Shaping", "Promotes a culture of purpose and continual improvement.");
  }

  const pointFive = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Boosting Morale", "Increases engagement by helping people feel valued.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Data-Driven Decisions", "Uses data and analysis to inform smarter strategic choices.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Effective Resource Use", "Allocates time, tools, and people efficiently.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Developing Future Leaders", "Mentors and empowers the next generation.");
  }

  const challengesPointOne = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Groupthink Risk", "Consensus can override better ideas.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Over-Control", "May micromanage and limit team creativity.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Overemphasis on Results", "Outcome focus may impact morale and well-being.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Execution Gap", "Big ideas may lack clear, actionable steps.");
  }
  const challengesPointTwo = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Slow Decisions", "Considering everyone’s feelings slows urgent decisions.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Feedback Resistance", "Can push back against feedback that challenges their strategy.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Transactional Style", "Task orientation can feel impersonal to the team.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Sustaining Engagement", "Team enthusiasm can fade during slow or difficult phases.");
  }
  const challengesPointThree = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Maintaining Objectivity", "Emotional investment can cloud judgment.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Neglecting People + Culture", "May focus too heavily on goals at the expense of morale.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Short-Term Focus", "May prioritize quick wins over long-term goals.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Resistance to Change", "Conceptual ideas may face doubt or hesitation.");
  }
  const challengesPointFour = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("Avoiding Tough Conversations", "May delay confronting underperformance.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Scaling Difficulty", "Strategies that work small may not translate organization-wide.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Work-Life Pressure", "High drive can create burnout or imbalance.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Long-View Buy-In", "Stakeholders may prefer short-term wins over long-term vision.");
  }
  const challengesPointFive = () => {
    if (highestLeadershipStarter.includes('col'))
      return renderItem("High Time + Energy Demand", "Collaboration requires more time and bandwidth.");
    if (highestLeadershipStarter.includes('strat'))
      return renderItem("Decision Bottlenecks", "Team may over-rely on the leader for direction.");
    if (highestLeadershipStarter.includes('per'))
      return renderItem("Hard on Failure", "High expectations can make setbacks harder to process.");
    if (highestLeadershipStarter.includes('vis'))
      return renderItem("Feeling Misunderstood", "Unconventional thinking can lead to isolation.");
  }

  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <style>{styles.checkboxStyles}</style>
      <div style={styles.page}>
        <div style={styles.aboutSection} className="about-report-section">
          <h4 style={styles.title}>
            YOU REFLECT A {getLeadershipHeading()} LEADERSHIP STYLE
          </h4>
          <div style={styles.iconRow}>
            <img src={getLeadershipImg()} alt="" style={styles.iconImage}></img>
            <div>
              <p style={styles.iconText}>
                {getLeadershipInfo()}{" "}
              </p>
              <p style={styles.iconText2}>
                {getLeadershipInfo2()}
              </p>
            </div>
          </div>
          <p style={styles.iconText}>
            {getLeadershipInfo3()}
          </p>
          <p style={styles.iconText}>
            {getLeadershipInfo4()}
          </p>

        </div>
        <div style={styles.card}>
          <h4 style={styles.cardTitle}>
            POSSIBLE CONTRIBUTIONS OF A {getLeadershipHeading()} LEADER
          </h4>
          <ul style={styles.list}>
            {pointOne()}
            {pointTwo()}
            {pointThree()}
            {pointFour()}
            {pointFive()}
          </ul>
        </div>
        <div style={styles.cardChallenges}>
          <h4 style={styles.cardTitle}>
            POSSIBLE CHALLENGES FOR A {getLeadershipHeading()} LEADER
          </h4>
          <ul style={styles.list}>
            {challengesPointOne()}
            {challengesPointTwo()}
            {challengesPointThree()}
            {challengesPointFour()}
            {challengesPointFive()}
          </ul>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} />
    </div>
  )
}
